<h2 mat-dialog-title>{{item.inventoryString()}}</h2>
<mat-dialog-content class="mat-typography">
  <mat-form-field>
    <mat-label>Search equipment list</mat-label>
    <input matInput [(ngModel)]="templateFilter" (ngModelChange)="filterTemplates()"
      [matAutocomplete]="templateAuto">
    <mat-autocomplete #templateAuto="matAutocomplete" (optionSelected)="onTemplateSelect($event)">
      @for (e of filteredEquipment; track e) {
        <mat-option [value]="e.name">
          {{e.name}} ({{formatGp(e.price)}}, {{e.weight}}cn)
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  <br/>
  <mat-form-field>
    <mat-label>Name</mat-label>
    <input matInput [(ngModel)]="item.name"/>
  </mat-form-field>
  <br/>
  <mat-form-field>
    <mat-label>Weight</mat-label>
    <input matInput [(ngModel)]="item.weight" type="number"/>
  </mat-form-field>
  <br/>
  <mat-form-field>
    <mat-label>Quantity</mat-label>
    <input matInput [(ngModel)]="item.quantity" type="number"/>
  </mat-form-field>
  <br/>
  <mat-form-field>
    <mat-label>Description</mat-label>
    <textarea matInput [(ngModel)]="item.description"></textarea>
  </mat-form-field>
  <mat-dialog-actions>
    @if (!this.list) {
      <button mat-button color="warn" (click)="deleteItem()">Delete</button>
    }
    <span class="spacer"></span>
    @if (this.list) {
      <button mat-button [mat-dialog-close]="">Cancel</button>
    }
    <button color="primary" mat-raised-button (click)="upsertItem()" [mat-dialog-close]="" cdkFocusInitial>Done</button>
  </mat-dialog-actions>
</mat-dialog-content>
